// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aroma-secondary-nav[data-v-056aad9f]{z-index:20;border-bottom:1px solid #eceef2}.aroma-secondary-nav[data-v-056aad9f] .van-nav-bar__title{color:#24304a;font-size:4.53333vw;font-weight:600}.aroma-secondary-nav[data-v-056aad9f] .van-icon{color:#596afd}", ""]);
// Exports
module.exports = exports;
